import React, {Component} from 'react';
import ErrorPage from '../widgets/ErrorPage';

class NotFoundPage extends Component {
	render() {
		return (
			<ErrorPage className="NotFoundPage">
				<h1>
					<span className="icon icon-warning" />
					Oops, the page or resource you requested could not be found
				</h1>
				<p>
					Sorry about this! The link you used may have been old, or you may have uncovered a bug in
					our software.
				</p>
				<p>
					Please let our{' '}
					<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
						support team
					</a>{' '}
					know about this.
				</p>
			</ErrorPage>
		);
	}
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/chrome/NotFoundPage.js